import { createApp } from 'vue';
import App from './App.vue';
import 'leaflet/dist/leaflet.css';
import './styles/main.css';

createApp(App).mount('#app');
